module.exports = __webpack_public_path__ + "img/vehicles.fc0f84f4.svg";